import { FC } from "react";
import MaskedInput from "react-text-mask";

export interface CEPMaskProperties {
    inputRef: (ref: HTMLInputElement | null) => void;
    guide?: boolean;
}

const CEPMask: FC<CEPMaskProperties> = (props: CEPMaskProperties) => {
    const { inputRef, ...other } = props;
    const masks = [/\d/, /\d/, /\d/,/\d/,/\d/,'-', /\d/, /\d/, /\d/]
    return (
        <MaskedInput
            {...other}
            ref={(ref: any) => {
                inputRef(ref ? ref.inputElement : null);
            }}
            mask={masks}
            placeholderChar={'\u2000'}
            showMask
            guide={other?.guide || false}
        />
    );
}

export { CEPMask }